import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { UploadFileHistoryOverviewKey } from 'api/Wallet/Types/UploadFileHistoryOverviewDto'
import { formatLocalDateUTC } from 'utils/date'

import './Create/transaction.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const transactionBulkTransactionFileUploadHistory: GridColumn[] = [
  {
    title: 'Date Created',
    field: UploadFileHistoryOverviewKey.dateCreated,
    cell: (props: GridCellProps) => (
      <td className='transaction-columns__date'>
        {formatLocalDateUTC(props.dataItem.dateCreated, true)}
      </td>
    ),
    show: true,
    resizable: true,
    filter: 'text',
  },
  {
    title: 'Date Finished',
    field: UploadFileHistoryOverviewKey.dateFinished,
    cell: (props: GridCellProps) => (
      <td className='transaction-columns__date'>
        {formatLocalDateUTC(props.dataItem.dateFinished, true)}
      </td>
    ),
    show: true,
    resizable: true,
    filter: 'text',
  },
  {
    title: 'Records Created',
    field: UploadFileHistoryOverviewKey.recordsCreated,
    show: true,
  },
  {
    title: 'Failed Records',
    field: UploadFileHistoryOverviewKey.failedRecords,
    show: true,
  },
  {
    title: 'User',
    field: UploadFileHistoryOverviewKey.user,
    show: true,
    filterable: true,
    width: 220,
    minResizableWidth: 220,
    filter: 'text',
  },
]
